var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',_vm._b({staticClass:"copy-button",attrs:{"variant":_vm.copyColor,"title":_vm.$t('copy')},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.copy.apply(null, arguments)}}},'b-button',_vm.buttonProps,false),[_c(_vm.copyIcon,{tag:"component"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }